// Splits a field value into plain-text and {{ … }} expression tokens for the
// highlight overlay. An unclosed {{ … (still being typed) is highlighted to
// the end of the value.

export interface ExpressionToken {
  text: string
  isExpression: boolean
}

const EXPRESSION_RE = /\{\{[\s\S]*?\}\}|\{\{[\s\S]*$/g

export const tokenizeExpressions = (value: string): ExpressionToken[] => {
  const tokens: ExpressionToken[] = []
  let last = 0
  EXPRESSION_RE.lastIndex = 0
  for (let m = EXPRESSION_RE.exec(value); m !== null; m = EXPRESSION_RE.exec(value)) {
    if (m.index > last) tokens.push({ text: value.slice(last, m.index), isExpression: false })
    tokens.push({ text: m[0], isExpression: true })
    last = m.index + m[0].length
    // Guard against zero-length matches looping forever.
    if (m[0].length === 0) break
  }
  if (last < value.length) tokens.push({ text: value.slice(last), isExpression: false })
  return tokens
}
